export const maybeThrowBasedOnResponseStatus = (status: number) => {
    if (ForbiddenError.codes.includes(status)) {
        throw new ForbiddenError()
    }

    if (FatalError.codes.includes(status)) {
        throw new FatalError()
    }
}

export class ForbiddenError extends Error {
    static codes = [403, 401]
    static message = 'Forbidden'

    constructor(message?: string) {
        super(message ? message : ForbiddenError.message)
    }
}

export class FatalError extends Error {
    static codes = [500]
    static message = 'Internal server error'

    constructor(message?: string) {
        super(message ? message : FatalError.message)
    }
}

export class NotFoundError extends Error {
    static codes = [404]
    static message = 'Page not found'

    constructor(message?: string) {
        super(message ? message : NotFoundError.message)
    }
}

export class ServerError extends Error {
    statusCode: number

    constructor(statusCode: number, cause?: string | Error) {
        super('Server error with code ' + statusCode, { cause })

        this.statusCode = statusCode
    }
}

export class RedirectError extends Error {
    redirectUrl: string;
    statusCode: number;

    constructor(redirectUrl: string, statusCode: number = 302) {
        super(`Redirecting to ${redirectUrl} with status code ${statusCode}`);

        this.redirectUrl = redirectUrl;
        this.statusCode = statusCode;
    }
}
